import Marquee from "react-fast-marquee";
import { Star, BadgeCheck, FileText, CalendarClock, Car } from "lucide-react";

const ITEMS = [
  { icon: Star, label: "Google Rated", stars: true },
  { icon: BadgeCheck, label: "100+ Vehicles Inspected" },
  { icon: FileText, label: "Professional Inspection Report" },
  { icon: CalendarClock, label: "Same Day Booking" },
  { icon: Car, label: "Mobile Inspection Available" },
];

export const TrustMarquee = () => (
  <section
    data-testid="trust-marquee"
    className="overflow-hidden border-y border-white/10 bg-[#0a0a0a] py-6"
  >
    <Marquee speed={32} gradient={false} pauseOnHover className="marquee-motion">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <div
          key={i}
          data-testid={i < ITEMS.length ? `marquee-item-${i}` : undefined}
          className="mx-10 flex items-center gap-3"
        >
          {item.stars ? (
            <span className="flex items-center gap-1">
              {[...Array(5)].map((_, s) => (
                <Star key={s} className="h-4 w-4 fill-gold text-gold" />
              ))}
            </span>
          ) : (
            <item.icon className="h-4 w-4 text-gold" />
          )}
          <span className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-white/60">
            {item.label}
          </span>
          <span className="ml-10 h-1.5 w-1.5 rounded-full bg-gold/40" />
        </div>
      ))}
    </Marquee>
  </section>
);
